<template>
  <v-container fluid>
    <div v-if="sleuthConfig">
      <div class="text-h5 text-left">Mod Settings</div>
      <v-divider></v-divider>
      <div class="text-subtitle-2 mt-2 mb-2 text-left grey--text text--darken-1">
        Select which mod actions you would like the bot to take
      </div>
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.sticky_comment" label="Sticky Comment" hint="Pin the bot's comment" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.lock_post" label="Lock Post" hint="Lock the repost" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.lock_response_comment" label="Lock Comment" hint="Lock the bot's comment" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.mark_as_oc" label="Mark OC" hint="Marks the post as OC" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.send_repost_modmail" label="Send Modmail" hint="Send modmail for repost" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.remove_repost" label="Remove Repost" hint="Removes the repost" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-select
              v-model="sleuthConfig.removal_reason"
              :items="removalReasons"
              item-text="title"
              item-value="title"
              label="Select"
              hint="Removal Reason"
              persistent-hint
              single-line
              :disabled="!sleuthConfig.remove_repost"
          ></v-select>

        </v-col>
        <v-col cols="12">
          <div class="text-h5 text-left">Adult Content Promoter Settings</div>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.adult_promoter_notify_mod_mail" label="Adult Promoter: Notify" hint="Notify modmail about adult promoters" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.adult_promoter_remove_post" label="Adult Promoter: Remove" hint="Remove posts by adult promoters" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-select
              v-model="sleuthConfig.adult_promoter_removal_reason"
              :items="removalReasons"
              item-text="title"
              item-value="title"
              label="Select"
              hint="Adult Promoter Removal Reason"
              persistent-hint
              single-line
              :disabled="!sleuthConfig.adult_promoter_remove_post"
          ></v-select>

        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.adult_promoter_ban_user" label="Adult Promoter: Ban" hint="Ban adult promoters" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-text-field v-model="sleuthConfig.adult_promoter_ban_reason" outlined  :label="`Adult Promoter Ban Reason`" :rules="[rules.banReasonCounter]"></v-text-field>
        </v-col>
        <v-col cols="12">
          <div class="text-h5 text-left">High Volume Reposter Settings</div>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.high_volume_reposter_notify_mod_mail" label="High Volume Reposter: Notify" hint="Notify modmail about high volume reposter" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.high_volume_reposter_remove_post" label="High Volume Reposter: Remove" hint="Remove post by high volume reposter" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-select
              v-model="sleuthConfig.high_volume_reposter_removal_reason"
              :items="removalReasons"
              item-text="title"
              item-value="title"
              label="Select"
              hint="High Volume Reposter Removal Reason"
              persistent-hint
              single-line
              :disabled="!sleuthConfig.high_volume_reposter_remove_post"
          ></v-select>

        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.high_volume_reposter_ban_user" label="High Volume Reposter: Ban" hint="Ban high volume reposters" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-text-field v-model="sleuthConfig.high_volume_reposter_ban_reason" outlined  :label="`High Reposter Ban Reason`" :rules="[rules.banReasonCounter]"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-text-field v-model="sleuthConfig.high_volume_reposter_threshold" outlined type="number" :label="`High Volume Reposter Threshold`" hint="0 is unlimited"></v-text-field>
        </v-col>

      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "ModSettings",
  props: {
    sleuthConfig: Object
  },
  data: () => ({
    removalReasons: [],
    rules: {
      banReasonCounter: value => value.length <= 300 || 'Max 300 characters'
    }
  }),
  methods: {
    getRemovalReasons() {
      this.$redditApi.get(`https://oauth.reddit.com/api/v1/${this.$route.params.subredditName}/removal_reasons`)
          .then(res => {
            console.log(res.data)
            // eslint-disable-next-line no-unused-vars
            for (const [key, value] of Object.entries(res.data.data)) {
              this.removalReasons.push(value)
            }
          })
    },
  },
  watch: {
    selectedSubreddit: function() {
      this.removalReasons = [];
      this.getRemovalReasons()
    }
  },
  mounted() {
    this.getRemovalReasons();
  }
}
</script>

<style scoped>

</style>
